import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/download',
        name: 'Download',
        component: () => import('../views/Download.vue'),
    },
    {
        path: '/aboutus',
        name: 'AboutUs',
        component: () => import('../views/AboutUs.vue'),
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

export default router;
